// src/App.jsx
import { HashRouter, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import LandingPage   from './components/LandingPage'
import Dashboard     from './components/Dashboard'
import DemoPage      from './components/DemoPage'
import TrayPopover   from './components/TrayPopover'
import DownloadPage from './components/DownloadPage'
import PrivacyPolicy from './components/PrivacyPolicy'
import VeteranDeveloper from './components/VeteranDeveloper'
import WhyNetwoke from './components/WhyNetwoke'

const isElectron = typeof window !== 'undefined' && !!window.electronAPI

export default function App() {
  // In Electron: use hash router so both /dashboard and /tray routes work
  // but default to the dashboard for the main window
  if (isElectron) {
    return (
      <HelmetProvider>
        <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            <Route path="/"         element={<Dashboard />} />
            <Route path="/tray"     element={<TrayPopover />} />
            <Route path="/privacy"   element={<PrivacyPolicy />} />
            <Route path="/veteran"   element={<VeteranDeveloper />} />
            <Route path="/why-netwoke" element={<WhyNetwoke />} />
          </Routes>
        </HashRouter>
      </HelmetProvider>
    )
  }

  // Browser (marketing site + demo)
  return (
    <HelmetProvider>
      <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/"      element={<LandingPage />} />
          <Route path="/demo"  element={<DemoPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/privacy"  element={<PrivacyPolicy />} />
          <Route path="/veteran"  element={<VeteranDeveloper />} />
          <Route path="/why-netwoke" element={<WhyNetwoke />} />
        </Routes>
      </HashRouter>
    </HelmetProvider>
  )
}
